module.exports = __webpack_public_path__ + "static/img/icon_battery.d9d40fb6.svg";